import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BackBtnWrapper, VideoPlayerWrapper, VideosPageWrapper } from "../components";
import { videosData } from "./videosData";
import ReactPlayer from "react-player";
import ICONS from "../../../constants/icons";

const ChosenVideo = () => {
  const [chosenVid, setChosenVid] = useState(null);
  const { videoId } = useParams();
  useEffect(() => {
    setChosenVid(videosData.find((item) => item.id === videoId));
  }, [videoId]);

  return (
    <VideosPageWrapper>
      <Link to="/app/belinson/videos">
        <BackBtnWrapper style={{ position: "absolute", top: "16px", left: "45px" }}>
          <ICONS.SidebarCloser />
          <div>Back</div>
        </BackBtnWrapper>
      </Link>
      {/* <BelinsonHeader>
        <TitleWrapper>{chosenVid?.title}</TitleWrapper>
      </BelinsonHeader> */}
      <VideoPlayerWrapper>
        <ReactPlayer
          url={chosenVid?.url}
          width={"85%"}
          height={"85vh"}
          playing={true}
          controls={true}
        />
      </VideoPlayerWrapper>
    </VideosPageWrapper>
  );
};

export default ChosenVideo;
